var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMheLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1018 343",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.492,238.341c13.65,6.864 28.386,13.342 44.108,19.387c5.328,10.054 21.714,15.007 39.094,13.543c146.02,45.112 356.65,55.509 565.968,-3.037l37.05,0c-131.908,70.27 -316.093,79.027 -449.485,72.074c-106.527,-5.552 -206.576,-33.456 -277.588,-73.419l30.583,0l10.27,-28.548l0,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.446,0c-107.79,66.424 -107.351,139.407 -39.646,197.721l-16.334,44.397c-91.833,-69.205 -101.94,-162.963 55.98,-242.118l0,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.353,266.889l77.869,0l55.115,-153.209l-2.529,136.017c-1.095,26.547 59.413,31.181 82.925,1.011l96.072,-136.017l-56.126,151.187l77.868,1.011l73.159,-201.548c24.276,-47.151 -87.928,-55.831 -119.44,0l-89.836,126.673l-4.799,-0.031l2.876,-136.452c-2.633,-40.809 -101.867,-35.878 -117.814,6.573l-75.341,204.785l0.001,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.015,177.018l-102.447,0l-33.564,89.594l-9.351,0l-61.782,0l-6.629,0l90.052,-240.376l77.762,0l-33.855,90.369l102.446,0l33.752,-90.092l77.762,0l-90.053,240.376l-77.762,0l33.669,-89.871Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.393,266.429c-13.203,0 -23.906,-10.703 -23.906,-23.906c0,-3.254 0.65,-6.356 1.828,-9.183l64.052,-170.838c9.242,-22.338 31.393,-38.071 57.25,-38.071l180.098,0l-23.155,60.926l-144.84,0c-8.403,0 -14.359,4.395 -18.896,11.245c-1.424,2.364 -2.662,5.355 -3.739,7.889c-1.497,3.52 -2.919,7.083 -4.303,10.656l153.588,0l-23.156,60.927l-153.603,0l-6.071,15.971c-1.26,3.316 -1.049,6.283 0.788,9.322c1.655,2.737 3.82,4.135 7.04,4.135l149.696,0l-23.156,60.927l-189.515,0l0,0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMheLogo);
export default __webpack_public_path__ + "static/media/MHELogo.944faeff2704368fffd064386e7aa3d5.svg";
export { ForwardRef as ReactComponent };